<div class="cdk-overlay-container" [ngClass]="{ 'dark-theme' : wizardService.isDarkTheme}">
  <div class="cdk-overlay-backdrop cdk-overlay-dark-backdrop cdk-overlay-backdrop-showing"></div>
  <div class="cdk-global-overlay-wrapper">
    <div [id]="wizardService.id" class="wizard">
      <!--
          TODO: Ideally, the decoration of top line (back/next/create/finish/...) should be done in separate template
          and separate component.
        -->
      <div class="setup">
        <div class="header">
          <div class="title" *ngIf="wizardService.currentStep">
            <div>{{wizardService.title}}</div>
            <div class="subTitle" *ngIf="wizardService.defaultParamsById.subTitle">
              <img
                *ngIf="wizardService.defaultParamsById.icon"
                [src]="wizardService.defaultParamsById.icon"
                alt=""
              />
              <span>{{wizardService.defaultParamsById.subTitle}}</span>
            </div>
            <!--<vibe-tooltips [id]="wizardService.currentStep.id"></vibe-tooltips>-->
          </div>
          <div class="control">
            <button
              mat-stroked-button
              class="add-new"
              [disabled]="wizardService.currentStep.disableBackBtn"
              *ngIf="wizardService.currentStep.config.index > 0 && !wizardService.isLoading"
              (click)="toggleBack()"
            >
              BACK
            </button>

            <ng-container #buttonPlaceholder> </ng-container>

            <div class="vertical-separator"></div>

            <button
              mat-flat-button
              *ngIf="!wizardService.isLastStep() && !wizardService.isFinishingStep()"
              [disabled]="!wizardService.currentStep.isValid() || wizardService.isLoading"
              (click)="toggleNext()"
              name="next"
            >
              NEXT
            </button>

            <button
              mat-flat-button
              *ngIf="wizardService.openAnother && wizardService.isLastStep() && !wizardService.hideFinishBtn"
              class="add-new"
              (click)="wizardService.onFinishOpenNew()"
              [disabled]="!wizardService.currentStep.isValid() || wizardService.isLoading"
            >
              CREATE AND ADD NEW
            </button>
            <button
              mat-flat-button
              *ngIf="wizardService.isLastStep() && !wizardService.isFinishingStep() && !wizardService.hideFinishBtn"
              (click)="toggleFinish()"
              [disabled]=" !wizardService.currentStep.isValid() || wizardService.isLoading"
            >
              {{wizardService.finishStep}}
            </button>

            <button mat-flat-button *ngIf="wizardService.isFinishingStep()" (click)="toggleClose()">
              <span *ngIf="wizardService.showExitInsteadOfClose()">EXIT</span>
              <span *ngIf="!wizardService.showExitInsteadOfClose()">CLOSE</span>
            </button>

            <div class="vertical-separator"></div>

            <mat-icon class="close" (click)="toggleClose()">clear</mat-icon>
          </div>
        </div>

        <div class="body">
          <div class="content">
            <ng-container *ngIf="!wizardService.noResponseError">
              <span class="error" *ngFor="let error of wizardService.errors">{{error}}</span>
            </ng-container>
            <div class="step-content">
              <ng-container #contentPlaceholder> </ng-container>
            </div>
          </div>
        </div>
      </div>
      <ng-container #subContentPlaceholder>
        <!-- an important note for developers of sub-content component:
            your html template for sub-content must start with this div+class:
            <div class="sub-content">..here your content</div>
           -->
      </ng-container>
    </div>
  </div>
</div>
